import { createTransform } from 'redux-persist'
import { CompanyPaymentsState, initialState } from './companyPaymentsSlice'
import { RootState } from '../../types/RootState'

export const transformer = createTransform<
  CompanyPaymentsState,
  Omit<CompanyPaymentsState, 'error'>,
  RootState
>(
  inboundState => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { error, ...persistedState } = inboundState
    return persistedState
  },
  outboundState => {
    const status: CompanyPaymentsState['status'] =
      outboundState.status === 'initial' ? outboundState.status : 'idle'
    return {
      ...outboundState,
      error: initialState.error,
      status,
    }
  },
  {
    whitelist: ['companyPayments'],
  },
)
